import config from '../../config';

export default {
  url: `${config.api.baseURL}/requests`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/requests/create.js